import React from "react";
import {
	Button,
	Card,
	CardActions,
	CardContent,
	Typography
} from "@material-ui/core";
import { Container } from "@prestosports/commons-ui";
import { AppRoutes } from "../../../routes/app-routes";
import ApiErrorBoundary from "./ApiErrorBoundary";

export default class UnhandledErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: error };
	}

	componentDidCatch(error, errorInfo) {
		// You can also log the error to an error reporting service
		// eslint-disable-next-line no-console
		console.error({ error, errorInfo });
	}

	render() {
		const { state, props } = this;
		const { hasError } = state;
		if (hasError) {
			return (
				<Container fullHeight>
					<Card>
						<CardContent>
							<Typography variant="h3" component="h2">
								Unexpected Error
							</Typography>
							<Typography variant="h5" component="h2">
								{hasError?.message}
							</Typography>
							<br />
							<Typography variant="h5" component="h2">
								{hasError?.stack}
							</Typography>
						</CardContent>
						<CardActions>
							<Button
								color="secondary"
								variant="contained"
								onClick={() => {
									window.location = AppRoutes.HOME.url;
								}}
							>
								Home
							</Button>
						</CardActions>
					</Card>
				</Container>
			);
		}

		// If no unhandled error, verify api errors.
		return <ApiErrorBoundary>{props.children}</ApiErrorBoundary>;
	}
}
